import { CreateProfileParams } from 'api/lms-profiles/Create'
import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { ILmsProfileModel } from 'models/lmsProfile.model'

export const LMS_PROFILES_CREATE = 'LMS_PROFILES_CREATE'
export const LMS_PROFILES_CREATE_SUCCESS = 'LMS_PROFILES_CREATE_SUCCESS'
export const LMS_PROFILES_LIST_GET = 'LMS_PROFILES_LIST_GET'
export const LMS_PROFILES_LIST_SUCCESS = 'LMS_PROFILES_LIST_SUCCESS'
export const LMS_PROFILES_EDIT_PROFILE = 'LMS_PROFILES_GET_PROFILE'
export const LMS_PROFILES_EDIT_PROFILE_SUCCESS =
  'LMS_PROFILES_GET_PROFILE_SUCCESS'
export const LMS_PROFILES_DELETE_PROFILE = 'LMS_PROFILES_DELETE_PROFILE'
export const LMS_PROFILES_DELETE_PROFILE_SUCCESS =
  'LMS_PROFILES_DELETE_PROFILE_SUCCESS'
export const LMS_PROFILES_UPLOAD = 'LMS_PROFILES_UPLOAD'
export const LMS_PROFILES_UPLOAD_SUCCESS = 'LMS_PROFILES_UPLOAD_SUCCESS'
export const LMS_ALL_PROFILES_LIST = 'LMS_ALL_PROFILES_LIST'
export const LMS_ALL_PROFILES_LIST_SUCCESS = 'LMS_ALL_PROFILES_LIST_SUCCESS'

export const Actions = {
  lmsProfilesCreate: (data: CreateProfileParams) =>
    createAction(LMS_PROFILES_CREATE, data),
  lmsProfilesCreateSuccess: (data: any) =>
    createAction(LMS_PROFILES_CREATE_SUCCESS, data),
  lmsProfilesListSuccess: (
    data: ILmsProfileModel[],
    total: number,
    perPage: number,
    sort: any[]
  ) => createAction(LMS_PROFILES_LIST_SUCCESS, { data, total, perPage, sort }),
  lmsProfilesEditProfileSuccess: (data: ILmsProfileModel) =>
    createAction(LMS_PROFILES_EDIT_PROFILE_SUCCESS, data),
  lmsProfilesDeleteProfileSuccess: (data: number) =>
    createAction(LMS_PROFILES_DELETE_PROFILE_SUCCESS, data),
  lmsProfileListReload: () =>
    createAction(LMS_PROFILES_LIST_GET, { page: 1, searchText: '', sort: [] }),
  lmsProfilesUploadSuccess: (data: ILmsProfileModel[]) =>
    createAction(LMS_PROFILES_UPLOAD_SUCCESS, data),
  lmsAllProfiles: () => createAction(LMS_ALL_PROFILES_LIST),
  lmsAllProfilesSuccess: (data: any) =>
    createAction(LMS_ALL_PROFILES_LIST_SUCCESS, data),
}

export type Actions = ActionsUnion<typeof Actions>
